import { useCallback, useState } from 'react'
import useStateBackLink from 'hooks/useStateBackLink'
import useNewAbsenceRequest from 'pages/Tasks/AbsenceRequest/New/useNewAbsenceRequest'
import { useHistory } from 'react-router'
import routes from 'services/RoutesProvider/routes'
import type { CreateAbsenceRequestResultT } from 'types'

export const useNewAbsenceRequestPage = () => {
  const history = useHistory()
  const [isBalancesDrawerOpen, setIsBalanceDrawerOpen] = useState(false)
  const { backLink, setBackLink } = useStateBackLink()

  const onSubmitComplete = useCallback(
    (result: CreateAbsenceRequestResultT) => {
      if (backLink !== routes.shifts) {
        setBackLink(routes.tasks)
      }

      history.push(routes.taskDetails(result.createAbsence.taskUuid))
    },
    [backLink, history, setBackLink],
  )
  const absenceRequestProps = useNewAbsenceRequest(onSubmitComplete)

  return { ...absenceRequestProps, isBalancesDrawerOpen, setIsBalanceDrawerOpen }
}
